import { GOAL_EVENT_TYPE } from '@/constants/goal'
import style from '@/styles/_styleConfigurations.scss'

export const KR_MEASURING_UNIT = {
  PERCENTAGE: 'percentage',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  MONEY: 'money'
}
export const KR_STATUS = {
  ON_TRACK: 'on-track',
  BEHIND: 'behind',
  AT_RISK: 'at-risk'
}
export const KR_STATUS_COLOR = {
  [KR_STATUS.ON_TRACK]: style.onTrack,
  [KR_STATUS.BEHIND]: style.behind,
  [KR_STATUS.AT_RISK]: style.atRisk
}
export const KR_MEASURING_SYMBOL = {
  [KR_MEASURING_UNIT.PERCENTAGE]: '%',
  [KR_MEASURING_UNIT.NUMBER]: '#',
  [KR_MEASURING_UNIT.BOOLEAN]: '/',
  [KR_MEASURING_UNIT.MONEY]: '$'
}

export const EXT_LOOKUP = {
  GOOGLE_SPREADSHEET: 'google_spreadsheet',
  NONE: 'none'
}

export const KR_ACTIONS = {
  EDIT_KR: 'editKR'
}

// These are events of KR shown in Activity Section on KR Page, KR Activity Modal
export const KR_ACTIVITY_EVENTS = [
  GOAL_EVENT_TYPE.CHECKIN,
  GOAL_EVENT_TYPE.CLOSED,
  GOAL_EVENT_TYPE.REOPENED,
  GOAL_EVENT_TYPE.COMMENT,
  GOAL_EVENT_TYPE.KR_CREATED,
  GOAL_EVENT_TYPE.AWARD,
  GOAL_EVENT_TYPE.OWNERSHIP_CHANGED,
  GOAL_EVENT_TYPE.FIELD_CHANGED
]

export const KR_ROW = 'kr-row'

export CHECKIN_TEMPLATE from '!raw-loader!./checkinTemplate.html'

export const KR_TABLE = {
  KR: {
    width: 390 * Math.min(window.innerWidth / 1000, 1)
  },
  NUMBERS: {
    width: 140
  },
  TEAM: {
    width: 107
  },
  STATUS: {
    width: 90
  },
  CHECKIN: {
    width: 100
  },
  OPTIONS: {
    width: 50
  },
  DAYS_SINCE_CHECKIN: {
    width: 140
  }
}

export const KR_STATUS_OPTIONS = [
  {
    label: 'Any status',
    id: ''
  },
  {
    label: 'On track',
    id: 'on-track'
  },
  {
    label: 'Behind',
    id: 'behind'
  },
  {
    label: 'At risk',
    id: 'at-risk'
  }
]

export const PROGRESS_PERIOD = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly'
}

export const PROGRESS_FREQUENCY_OPTIONS = [
  { label: 'Weekly', id: PROGRESS_PERIOD.WEEKLY },
  {
    label: 'Monthly',
    id: PROGRESS_PERIOD.MONTHLY
  }
]
